import { render, staticRenderFns } from "./PortfolioBuilder.vue?vue&type=template&id=45eef978&scoped=true&"
import script from "./PortfolioBuilder.vue?vue&type=script&lang=js&"
export * from "./PortfolioBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioBuilder.vue?vue&type=style&index=0&id=45eef978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eef978",
  null
  
)

export default component.exports